import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxMaxLine1Headline1Center,
  TextBoxMaxLine2Body1Center,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'
import { TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockDescriptionForSpecialRowCenterProps extends Omit<
  ITextBlockProps,
  'children'
> {
  title?: ITextBoxProps['title']
  description?: ITextBoxProps['title']
  descriptionPreWrap?: boolean
}

export const TextBlockDescriptionForSpecialRowCenter = ({
  title = '',
  description = '',
  rowGap = TextBlockRowGap.INDENT_0,
  descriptionPreWrap,
  ...rest
}: ITextBlockDescriptionForSpecialRowCenterProps): JSX.Element => (
  <TextBlock rowGap={rowGap} {...rest}>
    <TextBoxMaxLine1Headline1Center title={title} />
    <TextBoxMaxLine2Body1Center preWrap={descriptionPreWrap}>
      {description}
    </TextBoxMaxLine2Body1Center>
  </TextBlock>
)
